<script setup>

const props = defineProps({
  ann:{
    type: Object,
    required: true
  }
})
import { formatSeconds } from '@/front/composables/TimeFormatter'
import { AnnStore } from '@/front/stores/ann_store.js'
const annStore = AnnStore()

const { t } = useI18n({});
import { PauseIcon, Clock01Icon, GitBranchIcon, XVariableIcon, LinkForwardIcon, RefreshIcon } from 'hugeicons-vue'
</script>

<template>
  
  <div class="flex items-center gap-2 text-center">
    <!-- If pause, show PauseIcon -->
    <div v-if="ann.type_of === 'pause'" class="flex items-center gap-2">
      <PauseIcon class="h-6" />
      <div>Pause</div>
    </div>
    <!-- If jump, show Clock01Icon -->
    <div v-else-if="ann.type_of === 'jump'" class="flex items-center gap-2">
      <Clock01Icon class="h-6" />
      <div>{{ t('common.change_time') }}: {{ formatSeconds(ann.click_value) }}</div>
    </div>
    <!-- If switch, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'switch'" class="flex items-center gap-2">
      <GitBranchIcon class="h-10 w-10" />
      <div class="text-sm">{{ t('common.switch_video') }}: {{ ann.click_value ? ann.click_value.split('---')[0] : '' }}</div>
    </div>

    <!-- If variable, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'variable'" class="flex items-center gap-2">
      <XVariableIcon class="h-4 w-4" />
      <div class="text-sm">{{ t('common.set_variable') }}: {{ ann.variable }}</div>
    </div>

    <!-- If resourceTray, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'resourceTray'" class="flex items-center gap-2">
      <div class="text-sm">{{ t('common.open_magic_menu') }}</div>
    </div>

    <!-- If chatGPT, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'chatGPT'" class="flex items-center gap-2">
      <div class="text-sm">{{ t('common.ask_chatgpt') }}: {{ ann.click_value }}</div>
    </div>

    <!-- If resetViewer, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'reset_viewer'" class="flex items-center gap-2">
      <RefreshIcon class="h-5" />
      <div class="text-sm">{{ t('common.reset_viewer') }}</div>
    </div>
    <!-- If resetInteractions, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'reset_interactions'" class="flex items-center gap-2">
      <RefreshIcon class="h-5" />
      <div class="text-sm">{{ t('common.reset_interactions') }}</div>
    </div>

    <!-- If redirect, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'redirect'" class="flex items-center gap-2">
      <LinkForwardIcon class="h-6" />
      <div class="text-sm">{{ t('common.redirect_link') }}: {{ ann.click_value }}</div>
    </div>

    <!-- If message, show GitBranchIcon -->
    <div v-else-if="ann.type_of === 'back'" class="flex items-center gap-2">
      <GitBranchIcon class="h-6 w-6" />
      <div class="text-sm">{{ t('common.switch_to_previous_video') }}</div>
    </div>
</div>







</template>